export {default} from './bullet';